import './authentication.scss';
import { renderIcons } from './components/Icons/Icons';

/**
 * Base authentication modal class with common functionality
 */
export class BaseAuthModal {
  constructor() {
    this.$modal = $(this.constructor.selector());
    this.$form = this.$modal.find('form');
    this.$submitButton = this.$modal.find('.authentication__primary-button');
    this.$messageContainer = this.$modal.find('.authentication__message-container');
    this.$closeButton = this.$modal.find('.authentication__close-button');

    this.isSubmitting = false;
  }

  static selector() {
    return ''
  }

  addListeners() {
    this.$closeButton.on('click', () => {
      this.constructor.hide();
    });

    if (this.$form.length) {
      this.$form.off('submit').on('submit', (e) => this.handleSubmit(e));
    }
  }

  // Clear all form errors
  clearErrors() {
    // Remove error classes
    this.$form.find('.authentication__form-group').removeClass('has-error');

    // Remove error messages
    this.$form.find('.help-block').empty();

    // Clear the main message container
    this.$messageContainer.empty();
  }

  // Display field-specific errors
  displayErrors(errors) {
    if (!errors || typeof errors !== 'object') return;

    // Process each error field
    Object.entries(errors).forEach(([field, messages]) => {
      const $field = this.$form.find(`[name$="[${field}]"]`);
      if (!$field.length) return; // Skip if field not found

      // Get the container and mark as error
      const $container = $field.closest('.authentication__form-group');
      $container.addClass('has-error');

      // Find or create help-block for error message
      let $helpBlock = $container.find('.help-block');
      if (!$helpBlock.length) {
        $helpBlock = $('<div class="help-block"></div>');
        $container.append($helpBlock);
      }

      // Display error messages
      if (Array.isArray(messages)) {
        $helpBlock.html(messages.join('<br>'));
      } else if (typeof messages === 'string') {
        $helpBlock.html(messages);
      }
    });
  }

  // Display message to the user
  showMessage(message, type = 'info') {
    if (!message) return;

    // Clear previous messages
    this.$messageContainer.empty();

    // Check if this is a confirmation error that should show the resend link
    if (type === 'resend-confirmation') {
      // Create message element with resend link
      const $message = $(`<div class="authentication__message error">${message}</div>`);
      const $resendLink = $('<a href="#" class="authentication__resend-link">Resend confirmation link</a>');
      $message.append($resendLink);
      this.$messageContainer.append($message);

      // Add click handler for the resend link
      $resendLink.on('click', (e) => {
        e.preventDefault();
        this.clearErrors();
        ResendConfirmationModal.show();
      });
    } else {
      // Create regular message element
      const $message = $(`<div class="authentication__message ${type}">${message}</div>`);
      this.$messageContainer.append($message);
    }
  }

  // Method to reset the form fields
  resetForm() {
    this.$emailInput.val('');
    this.$form[0].reset();
    // Clear any validation states
    this.$form.find('.has-error').removeClass('has-error');
    this.$form.find('.help-block').html('');
  }

  getFormData() {
    const formData = new FormData(this.$form[0]);
    return formData;
  }

  // Validate with Yii's validation
  async validate() {
    // Clear previous errors
    this.clearErrors();

    if (this.$form.yiiActiveForm && typeof this.$form.yiiActiveForm('validate') === 'function') {
      const isValid = await this.$form.yiiActiveForm('validate');

      // Check if there are validation errors
      if (!isValid || $('.has-error').length > 0) {
        return false;
      }
    }

    return true;
  }

  // Handle form submission
  async handleSubmit(event) {
    event.preventDefault();
    event.stopImmediatePropagation(); // Prevent other handlers from executing

    if (this.isSubmitting || !this.$form.length) {
      return false;
    }

    // First use Yii's validation
    if (!await this.validate()) {
      return false;
    }

    this.isSubmitting = true;
    this.$submitButton.addClass('is-loading');

    // Disable close button and add title
    this.$closeButton.prop('disabled', true);
    this.$closeButton.attr('title', 'Cannot close while processing');

    // Collect form data
    const formData = this.getFormData();

    // Send AJAX request
    $.ajax({
      url: this.$form.attr('action'),
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      dataType: 'json',
      success: (response) => {
        this.handleSubmissionSuccess(response);
      },
      error: (xhr) => {
        this.handleSubmissionError(xhr);
      },
      complete: () => {
        this.handleSubmissionComplete();
      }
    });
  }

  handleSubmissionSuccess(response) {
    // implement this
  }

  handleSubmissionError(xhr) {
    try {
      const response = xhr.responseJSON;

      // Handle field errors if available
      if (response?.errors && Object.keys(response.errors).length > 0) {
        this.displayErrors(response.errors);
      } else if (response?.message) {
        this.showMessage(response.message, 'error');
      } else {
        this.showMessage('Something went wrong. Please try again.', 'error');
      }
    } catch (e) {
      console.error('Error parsing response:', e);
      this.showMessage('Something went wrong. Please try again.', 'error');
    }
  }

  handleSubmissionComplete() {
    this.isSubmitting = false;
    this.$submitButton.removeClass('is-loading');

    // Enable close button and remove title
    this.$closeButton.prop('disabled', false);
    this.$closeButton.removeAttr('title');
  }

  static bringModalToFront() {
    let maxZIndex = 0;

    $('.modal:visible').each(function () {
      const z = parseInt($(this).css('z-index'), 10);
      if (!isNaN(z)) {
        maxZIndex = Math.max(maxZIndex, z);
      }
    });

    // Nếu chưa có modal nào visible, mặc định là 1040 như Bootstrap
    if (maxZIndex === 0) {
      maxZIndex = 1040;
    }

    $(this.selector()).css('z-index', maxZIndex + 1);
  }


  /**
   * Show a modal and hide any other active modals
   */
  static show() {
    this.hideAll();

    // Show the requested modal
    $(this.selector()).addClass('is-active');

    this.bringModalToFront();
  }

  /**
   * Hide a specific modal
   */
  static hide() {
    $(this.selector()).removeClass('is-active');
  }

  /**
   * Toggle a modal's visibility
   * @param {string} modalId - The ID of the modal to toggle
   */
  static toggle() {
    if ($(this.selector()).hasClass('is-active')) {
      this.hide();
    } else {
      this.show();
    }
  }

  /**
   * Hide all modals
   */
  static hideAll() {
    $('.authentication').removeClass('is-active');
  }
}

export class RegisterModal extends BaseAuthModal {
  constructor() {
    super();

    this.$emailInput = $('#register-form-email');
    this.$usernameInput = $('#register-form-username');
    this.$showLoginLink = $('#show-login-modal');

    this.addListeners();
  }

  static selector() {
    return '#register-modal'
  }

  getFormData() {
    const formData = super.getFormData();

    if (globalConfigs.successUrl) {
      formData.append('successUrl', globalConfigs.successUrl);
    }

    // Only send path, query and hash (everything after domain)
    const cleanUrl = window.location.pathname + window.location.search + window.location.hash;
    formData.append('currentUrl', cleanUrl);

    return formData;
  }

  handleSubmissionSuccess(response) {
    if (response.success) {
      // Track successful signup with email
      const emailVal = (this.$emailInput && this.$emailInput.val) ? String(this.$emailInput.val() || '').trim() : '';

      try {
        if (window.amplitude && amplitude.track) {
          amplitude.track('User Signed up', { email: emailVal });
        }
      } catch (e) {
        console.error(e);
      }

      try {
        if (window.trackdesk) {
          window.trackdesk('bagless', 'externalCid', {
            externalCid: emailVal,
            revenueOriginId: '89b8de63-5ba9-443e-9592-21f8a9a3cf0b'
          });
        }
      } catch (e) {
        console.error(e);
      }

      // Set Lime Connect contact properties with email and generated username
      try {
        const usernameVal = (this.$usernameInput && this.$usernameInput.val) ? String(this.$usernameInput.val() || '').trim() : '';
        const props = {};
        if (emailVal) props.email = emailVal;
        if (usernameVal) props.name = usernameVal;
        if (Object.keys(props).length) {
          window.baglessSetLimeConnectContact && window.baglessSetLimeConnectContact(props);
        }
      } catch (e) {
        console.error(e);
      }

      // Clear the form fields before showing the success modal
      this.resetForm();
      EmailSentModal.showWithType('verify-email');
    } else {
      // Display field errors if present
      if (response.errors && Object.keys(response.errors).length > 0) {
        this.displayErrors(response.errors);
      } else if (response.message) {
        this.showMessage(response.message, 'error');
      }
    }
  }

  // register listeners
  addListeners() {
    super.addListeners();

    // Email input to auto-generate username
    this.$emailInput.on('input', () => {
      const email = this.$emailInput.val();
      if (email) {
        const emailParts = email.match(/^(.+)@/);
        if (emailParts && emailParts[1]) {
          this.$usernameInput.val(emailParts[1]);
        }
      }
    });

    // Show login modal link
    this.$showLoginLink.on('click', (e) => {
      e.preventDefault();
      LoginModal.show();
    });
  }
}

export class LoginModal extends BaseAuthModal {
  constructor() {
    super();
    this.$emailInput = $('#login-form-login');
    this.$magicLinkButton = $('#magic-link-button');
    this.$showRegisterLink = $('#show-register-modal');
    this.$forgotPasswordLink = $('#show-forgot-password-modal');
    // init states
    this.isSendingMagicLink = false;

    this.addListeners();
  }

  static selector() {
    return '#login-modal'
  }

  getFormData() {
    const formData = super.getFormData();

    // Only send path, query and hash (everything after domain)
    const cleanUrl = window.location.pathname + window.location.search + window.location.hash;
    formData.append('currentUrl', cleanUrl);

    if (globalConfigs.successUrl) {
      formData.append('successUrl', globalConfigs.successUrl);
    }

    return formData;
  }

  handleSubmissionSuccess(response) {
    if (response.success) {
      // On login, set Lime Connect email if available in the form
      try {
        const emailVal = (this.$emailInput && this.$emailInput.val) ? String(this.$emailInput.val() || '').trim() : '';
        if (emailVal) {
          window.baglessSetLimeConnectContact && window.baglessSetLimeConnectContact({ email: emailVal });
        }
      } catch (e) { }
      if (response.originalUrl) {
        window.location.href = response.originalUrl;
      } else {
        window.location.reload();
      }
    } else {
      // Display field errors if present
      if (response.errors && Object.keys(response.errors).length > 0) {
        this.displayErrors(response.errors);
      } else if (response.message) {
        this.showMessage(response.message, response.showResendLink ? 'resend-confirmation' : 'error');
      }
    }
  }

  // Handle magic link request
  async handleMagicLinkRequest() {
    if (this.isSendingMagicLink) return;

    // First use Yii's validation
    if (!await this.validate()) {
      return false;
    }

    this.isSendingMagicLink = true;
    this.$magicLinkButton.addClass('is-loading');

    // Disable close button and add title
    this.$closeButton.prop('disabled', true);
    this.$closeButton.attr('title', 'Cannot close while processing');

    // Create form data with the email, current URL, and recaptcha
    const formData = this.getFormData();

    formData.delete('login-form[password]');

    // Add current URL to the form data
    const cleanUrl = window.location.pathname + window.location.search + window.location.hash;
    formData.append('currentUrl', cleanUrl);

    if (globalConfigs.successUrl) {
      formData.append('successUrl', globalConfigs.successUrl);
    }

    // Send AJAX request
    $.ajax({
      url: '/user/security/magic-link',
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      dataType: 'json',
      success: (response) => {
        if (response.success) {
          EmailSentModal.showWithType('magic-link');
        } else {
          // Display field errors if present
          if (response.errors && Object.keys(response.errors).length > 0) {
            this.displayErrors(response.errors);
          } else if (response.message) {
            this.showMessage(response.message, response.showResendLink ? 'resend-confirmation' : 'error');
          }
        }
      },
      error: (xhr) => {
        this.handleSubmissionError(xhr);
      },
      complete: () => {
        this.isSendingMagicLink = false;
        this.$magicLinkButton.removeClass('is-loading');

        // Enable close button and remove title
        this.$closeButton.prop('disabled', false);
        this.$closeButton.removeAttr('title');
      }
    });
  }

  // register listeners
  addListeners() {
    super.addListeners();

    // Magic link button
    this.$magicLinkButton.on('click', this.handleMagicLinkRequest.bind(this));

    // Show register modal link
    this.$showRegisterLink.on('click', (e) => {
      e.preventDefault();
      RegisterModal.show();
    });

    // Show forgot password modal link
    this.$forgotPasswordLink.on('click', (e) => {
      e.preventDefault();
      ForgotPasswordModal.show();
    });
  }
}

export class EmailSentModal extends BaseAuthModal {
  constructor() {
    super();

    this.primaryButton = this.$modal.find('.authentication__primary-button');

    this.addListeners();
  }

  static selector() {
    return '#email-sent-modal';
  }

  /**
   * Show the email sent modal with a specific message type
   * @param {string} type - The type of email sent ('verify', 'magic-link', 'reset-password')
   */
  static showWithType(type) {
    const $modal = $(this.selector());

    $modal.find('.authentication__form-note').hide();
    $modal.find(`[data-purpose="${type}"]`).show();

    // Show the modal
    this.show();
  }

  addListeners() {
    super.addListeners();

    this.primaryButton.on('click', () => EmailSentModal.hide());
  }
}

export class ForgotPasswordModal extends BaseAuthModal {
  constructor() {
    super();
    this.$showLoginLink = $('#show-login-modal-from-forgot');

    this.addListeners();
  }

  static selector() {
    return '#forgot-password-modal'
  }

  handleSubmissionSuccess(response) {
    if (response.success) {
      EmailSentModal.showWithType('reset-password');
    } else {
      // Display field errors if present
      if (response.errors) {
        this.displayErrors(response.errors);
      } else if (response.message) {
        this.showMessage(response.message, 'error');
      }
    }
  }

  // register listeners
  addListeners() {
    super.addListeners();

    this.$showLoginLink.on('click', (e) => {
      e.preventDefault();
      LoginModal.show();
    });
  }
}

export class ResetPasswordModal extends BaseAuthModal {
  constructor() {
    super();

    this.addListeners();
  }

  static selector() {
    return '#reset-password-modal';
  }

  handleSubmissionSuccess(response) {
    if (response.success) {
      // Show success message and redirect to login modal
      this.showMessage(response.message, 'success');

      // Clear the form
      this.$form[0].reset();

      // Redirect to login modal after a short delay
      setTimeout(() => {
        LoginModal.show();

        this.$submitButton.removeClass('is-loading');
      }, 5000);
    } else {
      // Display field errors if present
      if (response.errors) {
        this.displayErrors(response.errors);
      } else if (response.message) {
        this.showMessage(response.message, 'error');
      }
    }
  }

  handleSubmissionComplete() {
    this.isSubmitting = false;

    // Enable close button and remove title
    this.$closeButton.prop('disabled', false);
    this.$closeButton.removeAttr('title');
  }
}

/**
 * Resend Confirmation Modal
 */
export class ResendConfirmationModal extends BaseAuthModal {
  constructor() {
    super();

    this.$showLoginLink = $('#show-login-modal-from-resend');

    this.addListeners();
  }

  static selector() {
    return '#resend-confirmation-modal'
  }

  handleSubmissionSuccess(response) {
    if (response.success) {
      // Show success message and email sent modal
      EmailSentModal.showWithType('verify-email');
    } else {
      // Display field errors if present
      if (response.errors) {
        this.displayErrors(response.errors);
      } else if (response.message) {
        this.showMessage(response.message, 'error');
      }
    }
  }

  // register listeners
  addListeners() {
    super.addListeners();

    this.$showLoginLink.on('click', (e) => {
      e.preventDefault();
      LoginModal.show();
    });
  }
}

// Create singleton instances
const registerModal = new RegisterModal();
const loginModal = new LoginModal();
const emailSentModal = new EmailSentModal();
const forgotPasswordModal = new ForgotPasswordModal();
const resetPasswordModal = new ResetPasswordModal();
const resendConfirmationModal = new ResendConfirmationModal();

const globalConfigs = {
  successUrl: null,
};

const createModalOpener = (modal) => (message, messageType, configs = {}) => {
  $('#user-menu').removeClass('is-active');

  modal.constructor.show?.();

  // Show message if provided
  if (message) {
    modal.showMessage(message || '', messageType || 'info');
  }

  if (Object.hasOwn(configs || {}, 'successUrl')) {
    globalConfigs.successUrl = configs.successUrl;
  }
}

window.openRegisterModal = createModalOpener(registerModal);
window.openLoginModal = createModalOpener(loginModal);
window.openEmailSentModal = createModalOpener(emailSentModal);
window.openForgotPasswordModal = createModalOpener(forgotPasswordModal);
window.openResetPasswordModal = createModalOpener(resetPasswordModal);
window.openResendConfirmationModal = createModalOpener(resendConfirmationModal);

$(document).ready(() => {
  // Apply theme
  const darkThemeRoutes = ['/worlds/view'];
  if (darkThemeRoutes.includes(window.location.pathname)) {
    $('.authentication').addClass('authentication--dark');
  }

  // Append icons to elements with data-append-icon attribute
  renderIcons();
});
